import { Box, HStack } from '@talos/kyoko';
import styled from 'styled-components';

const OVERFLOW_TOUCH_SCROLL_CSS = `
  overflow-x: hidden;
  overscroll-behavior-x: none;
  touch-action: pan-y;
`;

export const OverflowModalWrapper = styled(Box)`
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  ${OVERFLOW_TOUCH_SCROLL_CSS}
`;

/** Contains DND so drags do not translate into horizontal viewport / rubber-band scroll. */
export const OverflowDndArea = styled(Box)`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  ${OVERFLOW_TOUCH_SCROLL_CSS}
`;

export const OverflowItemsList = styled(Box)`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  overscroll-behavior-x: none;
  touch-action: pan-y;
  padding: ${({ theme }) => `${theme.spacing8}px ${theme.spacing8}px ${theme.spacing32}px`};
  gap: ${({ theme }) => theme.spacing2}px;
  display: flex;
  flex-direction: column;
`;

export const OverflowHeader = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const OverflowRow = styled(HStack)`
  max-width: 100%;
  overflow: hidden;
  border-radius: ${({ theme }) => theme.spacing8}px;
  background: ${({ theme }) => theme.colors.gray['020']};
  padding-left: ${({ theme }) => theme.spacing4}px;
  padding-right: ${({ theme }) => theme.spacing12}px;
  flex: 0 0 auto;
`;

export const OverflowRowButton = styled.button`
  display: flex;
  align-items: center;
  background: transparent;
  border: none;
  color: inherit;
  text-align: left;
  flex: 1 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  gap: ${({ theme }) => theme.spacing12}px;
  padding: ${({ theme }) => `${theme.spacing12}px ${theme.spacing8}px`};
`;

export const OverflowDragHandle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: -4px;
  padding: 8px;
  cursor: grab;
  color: ${({ theme }) => theme.colorTextSubtle};
  touch-action: none;

  &:active {
    cursor: grabbing;
  }
`;
